import { createSelector } from 'reselect';
import { selectViewportScreenSizeSelector } from '@aveneo/frontmoon-viewport-watcher/lib/modules/Viewport';

import { CITIES_NUMBER_ON_VIEWPORT } from './constants';

export const selectCatalog = (state) => state.catalog.catalog || [];

export const selectCitiesCatalog = (state) => state.catalog.citiesCatalog;

export const selectLandingCatalog = createSelector(
    selectCatalog,
    selectViewportScreenSizeSelector,
    (catalog, viewport) => {
        const baseItems = CITIES_NUMBER_ON_VIEWPORT[viewport];

        return {
            base: catalog.slice(0, baseItems),
            rest: catalog.slice(baseItems)
        };
    }
);
